<template>
  <div class="contenido-list">
    <div
      :class="{
                'contenido-item': true,
                'contenido-item-visible': (contenido.posicion==1 && NoAvailable && firstVisible) || contenidoVisible.id == contenido.id
            }"
      v-for="contenido in contenidos"
      :key="contenido.id"
    >
      <div
        :class="{
                    'contenido-item-title': !NoAvailable,
                    'contenido-item-title-curso-header': NoAvailable==true,
                }"
        @click="setContenidoVisible(contenido)"
      >
        <div class="container">{{ contenido.titulo }}</div>
      </div>
      <div
        class="contenido-item-contenido"
        :class="{
                'bg-white': NoAvailable
                }"
      >
        <div class="mb-4 contenido-item-descripcion">
          <div class="container" v-html="contenido.descripcion"></div>
        </div>

        <div
          class="container bg-white"
          style="margin-top:-4%"
          v-if="contenido.posicion==1 && registrado==0"
        >
          <div class="row">
            <div class="col col-sm-auto" style="text-align: left;">
              <a
                class="btn banner-button btn-banner-blue"
                href="#"
                @click="toggleRegistroModal(true)"
              >REGÍSTRATE AQUÍ</a>
            </div>
            <div class="col col-sm-auto" style="text-align: left;">
              <div
                style="padding-top: 10px;"
                class="contenido-video-bloqueado"
              >Para ver la primera clase gratis</div>
            </div>
          </div>
          <br />
          <br />
        </div>
        <div class="mb-4 contenido-item-descripcion">
          <div class="container">
            <div class="row">
              <ul>
                <li
                  v-for="video in contenido.contenidos_videos"
                  :key="'video-' + video.id"
                  class="mb-4"
                >
                  <div class="d-flex">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img :src="video.imagen" :alt="quitarTituloContenido(contenido, video)" />
                    </div>

                    <div
                      class="col-8 col-sm-8 col-md-9 d-flex align-items-center contenido-subitem"
                    >
                      <div class="w-100">
                        <h4>{{ quitarTituloContenido(contenido, video) }}</h4>
                        <small v-if="getDuracion(video) != ''">{{ getDuracion(video) }}</small>
                        <div
                          v-if="(contenido.gratis ||  tieneVideo(video))  && tieneLogin"
                          class="contenido-progreso"
                        >
                          <b-progress show-progress :max="100" :striped="false">
                            <b-progress-bar :value="getProgreso(video)">{{ getProgreso(video) }}%</b-progress-bar>
                          </b-progress>
                        </div>
                        <div
                          v-else
                          class="contenido-video-bloqueado"
                        >Aún no tiene acceso a este video.</div>
                        <button
                          class="btn"
                          v-if="(contenido.gratis || tieneVideo(video)) && tieneLogin"
                          @click="verVideo(video, contenido)"
                        >
                          <font-awesome-icon icon="play" />&nbsp;
                          <span>{{ getPlayText(video) }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li
                  v-for="descargable in contenido.contenidos_descargables"
                  :key="'descargable-' + descargable.id"
                  class="mb-4"
                >
                  <div class="d-flex" v-if="registrado>0">
                    <div class="col-4 col-sm-4 col-md-3">
                      <div class="contenido-descargable-icon-wrapper">
                        <img
                          src="https://res.cloudinary.com/dmx3pf3os/image/upload/v1543425252/icono_pdf.png"
                          class="contenido-descargable-icon"
                          alt="Descargable"
                        />
                      </div>
                    </div>

                    <div
                      class="col-8 col-sm-8 col-md-9 d-flex align-items-center contenido-subitem"
                    >
                      <div class="w-100">
                        <h4>Documento descargable {{getPosicionDescarga(contenido.contenidos_descargables,descargable.id)}}</h4>
                        <br />
                        <a
                          v-if="(contenido.gratis ||  tieneCurso)  && tieneLogin"
                          class="btn color-black contenido-descargable-boton"
                          :class="{ 'bg-white': !NoAvailable  }"
                          :style="{'background-color': NoAvailable ? '#dedede' : '' }"
                          :href="descargable.descargable"
                          target="_blank"
                        >
                          <img :src="require('@/assets/images/download.svg')" />
                          Descargar
                        </a>
                        <div
                          v-else
                          class="contenido-video-bloqueado"
                        >Aún no tiene acceso a este documento.</div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import bProgress from "bootstrap-vue/es/components/progress/progress";
import bProgressBar from "bootstrap-vue/es/components/progress/progress-bar";
import { format, toDate } from "date-fns";
import { es } from "date-fns/esm/locale";
import {
  getDuracionVideo,
  getProgresoVideo,
  quitarTituloContenido
} from "../utilities/data";

library.add(faPlay);

export default {
  props: ["contenidos", "tieneCurso", "registrado", "NoAvailable"],
  components: { FontAwesomeIcon, bProgress, bProgressBar },
  data() {
    return {
      contenidoVisible: {
        id: 0
      },
      progresos: [],
      firstVisible: true,
      contadorDescarga: 0
    };
  },
  computed: {
    ...mapState(["user"]),
    tieneLogin() {
      if (this.user.id == 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    getPosicionDescarga(contenidos_descargables, id) {
      let con = 0;
      let res = 0;

      contenidos_descargables.forEach(content => {
        con++;
        if (content.id == id) {
          res = con;
        }
      });

      return res;
    },
    toggleRegistroModal(toggle) {
      this.$store.commit("togglePortalRegistroModal", toggle);
    },

    getPlayText(video) {
      let progreso = this.getProgreso(video);
      if (progreso == 0) return "Ver";
      if (progreso == 100) return "Volver a ver";
      return "Continuar";
    },
    setContenidoVisible(contenido) {
      this.firstVisible = false;
      if (this.contenidoVisible.id == contenido.id)
        this.contenidoVisible = {
          id: 0
        };
      else this.contenidoVisible = contenido;
    },
    getProgreso(video) {
      return Math.floor(
        (getProgresoVideo(this.user, video.id) * 100) /
          parseInt(video.video_duracion)
      );
    },
    getDuracion(video) {
      return getDuracionVideo(video);
    },
    tieneVideo(video) {
      return this.user.videos.find(v => v.id == video.id) ? true : false;
    },
    numeroIntervalo(posicion_video_contenido) {
      if (posicion_video_contenido >= 1 && posicion_video_contenido <= 9) {
        return "0" + posicion_video_contenido;
      } else {
        return posicion_video_contenido;
      }
    },
    verVideo(video, contenido) {
      this.$router.push({
        name: "video",
        params: {
          id_video: video.id,
          id_p_video: this.numeroIntervalo(video.posicion),
          id_p_contenido: this.numeroIntervalo(contenido.posicion),
          guid_categoria:
            contenido.contenidos_categorias[0].categorias_contenidos[0].guid,
          guid_contenido: contenido.guid
        }
      });
    },
    getTituloDescargable(descargable) {
      return descargable.descargable.substring(
        descargable.descargable.lastIndexOf("/") + 1
      );
    },
    quitarTituloContenido(contenido, video) {
      return quitarTituloContenido(contenido, video);
    }
  }
};
</script>
